import { buildApiUrl, getApiHeaders } from '../../../config/api';
import { 
    AiTranslatorProfile, 
    AiTranslatorProfileCreatePayload, 
    AiTranslatorProfileUpdatePayload 
} from './types';

const BASE_URL = '/api/telephony/ai-agents/translator-profiles';

export const aiTranslatorProfilesApi = {
    getProfiles: async (params?: Record<string, any>) => {
        const queryParams = new URLSearchParams();
        if (params?.page) queryParams.append('page', params.page.toString());
        if (params?.limit) queryParams.append('limit', params.limit.toString());
        if (params?.search) queryParams.append('search', params.search);

        const response = await fetch(`${buildApiUrl(BASE_URL)}?${queryParams}`, {
            method: 'GET',
            headers: getApiHeaders()
        });
        if (!response.ok) throw new Error('Failed to fetch profiles');
        const payload = await response.json();
        const data = Array.isArray(payload?.data) ? payload.data : [];
        const meta = payload?.meta || payload?.pagination || { total: data.length, page: 1, limit: 25, totalPages: 1 };
        return { data, meta };
    },

    getProfile: async (id: string | number) => {
        const response = await fetch(buildApiUrl(`${BASE_URL}/${id}`), {
            method: 'GET',
            headers: getApiHeaders()
        });
        if (!response.ok) throw new Error('Failed to fetch profile');
        return response.json();
    },

    createProfile: async (data: AiTranslatorProfileCreatePayload) => {
        const response = await fetch(buildApiUrl(BASE_URL), {
            method: 'POST',
            headers: getApiHeaders(),
            body: JSON.stringify(data)
        });
        if (!response.ok) throw new Error('Failed to create profile');
        return response.json();
    },

    updateProfile: async (id: string | number, data: AiTranslatorProfileUpdatePayload) => {
        const response = await fetch(buildApiUrl(`${BASE_URL}/${id}`), {
            method: 'PUT',
            headers: getApiHeaders(),
            body: JSON.stringify(data)
        });
        if (!response.ok) throw new Error('Failed to update profile');
        return response.json();
    },

    deleteProfile: async (id: string | number) => {
        const response = await fetch(buildApiUrl(`${BASE_URL}/${id}`), {
            method: 'DELETE',
            headers: getApiHeaders()
        });
        if (!response.ok) throw new Error('Failed to delete profile');
        return response.json();
    },

    duplicateProfile: async (id: string | number) => {
        const response = await fetch(buildApiUrl(`${BASE_URL}/${id}/duplicate`), {
            method: 'POST',
            headers: getApiHeaders()
        });
        if (!response.ok) throw new Error('Failed to duplicate profile');
        return response.json();
    },

    getQuickList: async () => {
        const response = await fetch(buildApiUrl(`${BASE_URL}/quicklist`), {
            method: 'GET',
            headers: getApiHeaders()
        });
        if (!response.ok) throw new Error('Failed to fetch quicklist');
        return response.json();
    }
};
